module.exports = __webpack_public_path__ + "img/gw-standard-white.2491f70a.png";